import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useAdultModeQuery } from "@/hooks";
import MetaTags from "./index";
import { defaultMetatags } from "@/lib/constants";
import config from "@/lib/config";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
export function tags(episode, adultMode) {
  var _episode$meta_keyword, _episode$genres, _episode$genres$;

  var keywords = episode !== null && episode !== void 0 && episode.meta_keywords && (episode === null || episode === void 0 ? void 0 : (_episode$meta_keyword = episode.meta_keywords) === null || _episode$meta_keyword === void 0 ? void 0 : _episode$meta_keyword.length) > 0 ? episode.meta_keywords.join(",") : null;
  var genre = (episode === null || episode === void 0 ? void 0 : (_episode$genres = episode.genres) === null || _episode$genres === void 0 ? void 0 : (_episode$genres$ = _episode$genres[0]) === null || _episode$genres$ === void 0 ? void 0 : _episode$genres$.name) || "";

  if (adultMode) {
    return {
      title: "".concat(episode.name, "\u3092\u914D\u4FE1\u4E2D\uFF01 | SPOOX EX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9)"),
      keywords: keywords || defaultMetatags.adult.keywords,
      description: "".concat(episode.name, "\u306E\u518D\u751F\u753B\u9762\u3002SPOOX EX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9)\u3067\u306F\u3001\u4EBA\u6C17\u5973\u512A\u3084\u591A\u5F69\u306A\u30B8\u30E3\u30F3\u30EB\u306A\u3069\u3001\u69D8\u3005\u306A\u30A2\u30C0\u30EB\u30C8\u52D5\u753B\u3092\u914D\u4FE1\u4E2D\uFF01\n\n"),
      og: {
        type: "video.episode",
        url: "".concat(config.host.adult).concat(routes.watch(episode.id))
      },
      twitter: {
        card: "summary"
      }
    };
  } else {
    return {
      title: "".concat(episode.name, "\u3010").concat(genre, "\u3011\u306E\u52D5\u753B\u914D\u4FE1 | SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9)"),
      keywords: keywords || defaultMetatags.vod.keywords,
      description: "".concat(episode.name, "\u306E\u518D\u751F\u753B\u9762\u3002SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9)\u3067\u306F\u3001\u30B9\u30DD\u30FC\u30C4\u3084\u6620\u753B\u3084\u30A2\u30CB\u30E1\u3001\u97F3\u697D\u30E9\u30A4\u30D6\u306A\u3069\u3001\u69D8\u3005\u306A\u52D5\u753B\u3092\u914D\u4FE1\u4E2D\uFF01\u6708\u984D\u898B\u653E\u984C\u3067\u3082\u30011\u4F5C\u54C1\u304B\u3089\u8CFC\u5165\u3067\u3082\u697D\u3057\u3081\u307E\u3059\u3002\n"),
      og: {
        type: "video.episode",
        url: "".concat(config.host.vod).concat(routes.watch(episode.id))
      },
      twitter: {
        card: "summary"
      }
    };
  }
}
export default function WatchMetaTags(_ref) {
  var episode = _ref.episode;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultMode = _useAdultModeQuery.data.adultMode;

  var props = tags(episode, adultMode);
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread({}, props));
}